import React from "react";
import { useNavigate } from "react-router-dom";
import { FileText, ChevronRight } from "lucide-react";
import TopBar from "../../components/TopBar";

const PROCEDURE = [
    { slug: "anisakidosi", title: "Procedura prevenzione Anisakidosi", desc: "Gestione rischio Anisakis per pesce crudo o praticamente crudo." },
    { slug: "istamina", title: "Procedura prevenzione sviluppo Istamina", desc: "Misure preventive per ridurre/eliminare rischio istamina nei prodotti ittici." },
    { slug: "celiachia", title: "Procedura prodotti per Celiachia (senza glutine)", desc: "Gestione preparazioni e somministrazione senza glutine." },
    { slug: "pasta-pasticceria", title: "Procedura produzione pasta e pasticceria", desc: "Fasi operative e controlli per produzione interna." },
    { slug: "allergeni", title: "Procedura allergeni negli alimenti somministrati", desc: "Informazioni obbligatorie al consumatore e gestione schede." },
    { slug: "uova", title: "Procedura gestione uova", desc: "Ricevimento, conservazione, lavaggio, utilizzo e cottura." },
    { slug: "acqua-microfiltrata", title: "Procedura distributori acqua microfiltrata", desc: "Gestione erogatori, manutenzioni e controlli." },
];

export default function ProcedureListPage() {
    const navigate = useNavigate();

    return (
        <>
            <TopBar />

            <div className="p-4 md:p-6">
                <div className="mb-4">
                    <h1 className="text-xl md:text-2xl font-semibold text-slate-900">Procedure</h1>
                    <p className="text-slate-600">Seleziona una procedura per visualizzarla.</p>
                </div>

                <div className="grid gap-3">
                    {PROCEDURE.map((p) => (
                        <button
                            key={p.slug}
                            onClick={() => navigate(`/procedure/${p.slug}`)}
                            className="w-full text-left bg-white rounded-xl border border-slate-200 hover:border-slate-300 shadow-sm px-4 py-4 flex items-start gap-3"
                        >
                            <div className="mt-0.5">
                                <FileText className="w-5 h-5 text-slate-700" />
                            </div>
                            <div className="flex-1">
                                <div className="font-semibold text-slate-900">{p.title}</div>
                                {p.desc ? <div className="text-sm text-slate-600 mt-1">{p.desc}</div> : null}
                            </div>
                            <div className="mt-1">
                                <ChevronRight className="w-5 h-5 text-slate-400" />
                            </div>
                        </button>
                    ))}
                </div>
            </div>
        </>
    );
}